import $ from "jquery"
import { MDCTextField } from "@material/textfield"

let _instance = null

class InputfieldComponent {
	constructor() {
		if (_instance) {
			return _instance
		}

		// eslint-disable-next-line no-console
		console.log("InputfieldComponent::initialize()")
		this.textInputs = []
		this._initializeItems()

		$("body").on("bb-form-items-changed", () => {
			this._initializeItems()
		})

		_instance = this
	}

	_initializeItems() {
		const newInputs = []

		$(".mdc-text-field").each((index, textElement) => {
			if ($(textElement).data("mdc-textfield") === undefined) {
				const inputField = new MDCTextField(textElement)
				$(textElement).data("mdc-textfield", inputField)
				newInputs.push(inputField)

				inputField.foundation.adapter.registerInputInteractionHandler("change", () => {
					const $inputField = $(inputField.root).parent()
					$inputField.removeClass("error")
					$inputField.find(".error-msg").slideUp()

					$inputField.trigger("bb-input--change")
				})
			}
		})

		newInputs.forEach((text) => {
			this.textInputs.push(text)
			const $autocomplete = $(text.root).closest("fieldset").find(".mdc__autocomplete")

			$(text.input).on("blur", () => {
				if (
					text.input.getAttribute("placeholder") !== null &&
					text.label &&
					!text.input.classList.contains("hasDatepicker")
				) {
					text.label.root.classList.add("mdc-floating-label--float-above")
				}

				if ($autocomplete.length) {
					$autocomplete.slideUp()
				}
			})

			if (
				text.input.getAttribute("placeholder") !== null &&
				text.label &&
				!text.input.classList.contains("hasDatepicker")
			) {
				text.label.root.classList.add("mdc-floating-label--float-above")
			}

			if ($autocomplete.length) {
				$autocomplete.find("li").on("click", (event) => {
					text.foundation.setValue($(event.currentTarget).text())
					text.foundation.adapter.shakeLabel(false)
					$autocomplete.slideUp()
				})
			}

			/* Set Data Attribute of Password Confirm field */
			if (text.input.dataset.confirm && text.input.dataset.confirm === "-") {
				let $fieldset = $(text.root).closest("fieldset").prev()
				let passwordInputId = $fieldset.find('input[type="password"]').attr("id")

				$(text.input).attr("data-confirm", passwordInputId)
			}
		})
	}

	validate(input) {
		const $mdcTextField = $(input).closest(".mdc-text-field")
		const $fieldset = $mdcTextField.parent()
		const isValid = $mdcTextField.data("mdc-textfield").valid

		if (isValid) {
			$fieldset.removeClass("error")
			$fieldset.find(".read-error").attr("aria-hidden", true)
			$fieldset.find(".error-msg").slideUp()
		} else {
			$fieldset.addClass("error")
			$fieldset.find(".read-error").attr("aria-hidden", false)
			$fieldset.find(".error-msg").slideDown()
		}

		return isValid
	}

	validatePasswordConfirm(passwordInput) {
		let isValid = false,
			confirmId = passwordInput.getAttribute("data-confirm"),
			$inputField = $(passwordInput).closest("fieldset")

		this.textInputs.forEach((mdcInput) => {
			if (confirmId === mdcInput.input.id) {
				if (passwordInput.value && mdcInput.value === passwordInput.value) {
					isValid = true
				}
			}
		})

		if (isValid) {
			$inputField.removeClass("error")
			$inputField.find(".error-msg").slideUp()
		} else {
			$inputField.addClass("error")
			$inputField.find(".error-msg").slideDown()
		}
		return isValid
	}
}

export default new InputfieldComponent()
